import React from "react"
import LeftMenu from '../components/LeftMenu';
import RoleContent from "./RoleContent"
import MainHeader from "../components/MainHeader"

import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { menuPermissionHasAccess } from '../components/DataList';

export default function RoleManagement() {
    let navigate = useNavigate()
    React.useEffect(() => {
        (async () => {
            const menuperm = JSON.parse(secureLocalStorage.getItem('menuperm'));
            let hasUpdate = await menuPermissionHasAccess(menuperm, window.location.pathname)
            //console.log('could access page: ' + window.location.pathname + ' - ' + hasUpdate)
            if (!hasUpdate) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            }
        })()

    }, [])

    return (
        <div className="wrapper">
            <LeftMenu />

            <div className="main-panel">
                <MainHeader pageTitle="Admin | Role Management" />

                <div className="container">
                    <div className="page-inner">
                        <RoleContent />
                    </div>
                </div>
            </div>
        </div>
    )
}